import type { InventoryCount } from "../models/InventoryCount";
import type { KeyValue } from "../models/KeyValue";
import { CreateCrudService } from "./CrudServiceFactory";
export function InventoryCountService(warehouseCode?: string) {
  return CreateCrudService<InventoryCount, KeyValue>({
    PaginationInPath: true,
    WarehouseCode: warehouseCode,
    Route: "inventory-count",
    EntityName: "InventoryCount",
    DeleteAction: "DeleteInventoryCount",
    PartialFields: ["Code", "Code"],
    LoadingMessage: "Loading inventorycount records...",
    SavingMessage: "Saving inventorycount...",
    MapPartial: (x) => ({
      Key: String(x.Code ?? ""),
      Value: String(x.Name ?? x.Code ?? ""),
    }),
  });
}
